import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";

@Component({
  selector: "okr-metric-bar-boolean",
  templateUrl: "./okr-metric-bar-boolean.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OkrMetricBarBooleanComponent {
  @Input() public metric: Metric;
}
